import styled from "styled-components";

import { colors, typography, zIndex } from "src/assets/styles/settings";

export const ModalWrapper = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zIndex.modal};
`;

export const ModalOverlay = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: ${zIndex.modalOverlay};
`;

export const ModalDialog = styled.div`
  background: ${colors.white};
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  height: max-content;
  margin: auto;
  max-width: 360px;
  width: 100%;
  z-index: ${zIndex.modalDialog};
`;

export const ModalHeader = styled.div`
  border-bottom: 1px solid ${colors.light_grey};
  padding: 12px 20px;
`;

export const ModalTitle = styled.p`
  color: ${colors.black_bekko};
  display: inline-block;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: ${typography.font_weight.bold};
  line-height: ${typography.line_height};
  margin: 0;
`;

export const ModalBody = styled.div`
  padding: 16px 20px;
  position: relative;
`;
